module.exports = __webpack_public_path__ + "img/metaforo.4cf307db.png";